<template>
    <v-container fluid>
      <div class="modal-padding">
        <v-row>
            <v-col cols="12" sm="12">
                <div class="center-name">Are you sure you want to delete this item?</div>
            </v-col>          
        </v-row>
        <v-row>
            <v-col cols="12" sm="12">
              <div class="right-align yes-no-block">
                  <v-btn class="right-btn cust-btn" color="primary">Yes</v-btn>   
                  <v-btn class="right-btn cust-btn no-btn" color="primary">No</v-btn>           
              </div>
            </v-col>
        </v-row>
      </div>
    </v-container>
</template>
<script>
export default {
 name: 'DeleteNotification',   
 props:['onClose'],
  data () {    
     return {
       itemsdrop: ['All', 'xyz'],
     }
  }  
}
</script>